var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgQgPhone(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 393,
    height: 354,
    viewBox: "0 0 393 354",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_11_339)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 128,
    cy: 133.5,
    rx: 48,
    ry: 54.5,
    fill: "#1EE1FC",
    fillOpacity: 0.38
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_f_11_339)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 225,
    cy: 146,
    rx: 79,
    ry: 70,
    fill: "#1E7FF5",
    fillOpacity: 0.53
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_f_11_339)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 169,
    cy: 48,
    rx: 80,
    ry: 72,
    fill: "#FF3DEC",
    fillOpacity: 0.47
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_f_11_339)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 45,
    cy: 49,
    rx: 76,
    ry: 77,
    fill: "#ED254E",
    fillOpacity: 0.62
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter4_f_11_339)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 51.5,
    cy: 286.5,
    rx: 94.5,
    ry: 90.5,
    fill: "#1E7FF5",
    fillOpacity: 0.53
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter5_f_11_339)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 250.5,
    cy: 323,
    rx: 85.5,
    ry: 77,
    fill: "#D7F51E",
    fillOpacity: 0.37
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter6_f_11_339)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 351,
    cy: 281,
    rx: 76,
    ry: 77,
    fill: "#F82752",
    fillOpacity: 0.58
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter7_f_11_339)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 336,
    cy: 178,
    r: 77,
    fill: "#7939E1",
    fillOpacity: 0.46
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter8_f_11_339)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 359,
    cy: 71,
    rx: 74,
    ry: 77,
    fill: "#1EE1FC",
    fillOpacity: 0.38
  }))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter9_f_11_339)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 285,
    cy: 42,
    rx: 75,
    ry: 77,
    fill: "#70F51E",
    fillOpacity: 0.37
  }))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter10_f_11_339)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 127,
    cy: 216,
    rx: 75,
    ry: 77,
    fill: "#7939E1",
    fillOpacity: 0.46
  }))), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter11_f_11_339)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 32.5,
    cy: 167,
    rx: 71.5,
    ry: 77,
    fill: "#FF773D",
    fillOpacity: 0.44
  }))), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter12_f_11_339)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 139,
    cy: 313,
    rx: 59,
    ry: 67,
    fill: "#FF3DEC",
    fillOpacity: 0.47
  }))), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter13_f_11_339)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 238.5,
    cy: 225.5,
    rx: 73.5,
    ry: 59.5,
    fill: "#ED254E",
    fillOpacity: 0.62
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_11_339",
    x: 41,
    y: 40,
    width: 174,
    height: 187,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 19.5,
    result: "effect1_foregroundBlur_11_339"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_f_11_339",
    x: 107,
    y: 37,
    width: 236,
    height: 218,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 19.5,
    result: "effect1_foregroundBlur_11_339"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_f_11_339",
    x: 50,
    y: -63,
    width: 238,
    height: 222,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 19.5,
    result: "effect1_foregroundBlur_11_339"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_f_11_339",
    x: -70,
    y: -67,
    width: 230,
    height: 232,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 19.5,
    result: "effect1_foregroundBlur_11_339"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter4_f_11_339",
    x: -82,
    y: 157,
    width: 267,
    height: 259,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 19.5,
    result: "effect1_foregroundBlur_11_339"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter5_f_11_339",
    x: 126,
    y: 207,
    width: 249,
    height: 232,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 19.5,
    result: "effect1_foregroundBlur_11_339"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter6_f_11_339",
    x: 236,
    y: 165,
    width: 230,
    height: 232,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 19.5,
    result: "effect1_foregroundBlur_11_339"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter7_f_11_339",
    x: 220,
    y: 62,
    width: 232,
    height: 232,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 19.5,
    result: "effect1_foregroundBlur_11_339"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter8_f_11_339",
    x: 246,
    y: -45,
    width: 226,
    height: 232,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 19.5,
    result: "effect1_foregroundBlur_11_339"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter9_f_11_339",
    x: 171,
    y: -74,
    width: 228,
    height: 232,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 19.5,
    result: "effect1_foregroundBlur_11_339"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter10_f_11_339",
    x: 13,
    y: 100,
    width: 228,
    height: 232,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 19.5,
    result: "effect1_foregroundBlur_11_339"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter11_f_11_339",
    x: -78,
    y: 51,
    width: 221,
    height: 232,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 19.5,
    result: "effect1_foregroundBlur_11_339"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter12_f_11_339",
    x: 41,
    y: 207,
    width: 196,
    height: 212,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 19.5,
    result: "effect1_foregroundBlur_11_339"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter13_f_11_339",
    x: 126,
    y: 127,
    width: 225,
    height: 197,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 19.5,
    result: "effect1_foregroundBlur_11_339"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgQgPhone);
export default __webpack_public_path__ + "static/media/QGPhone.3eda9d3e51a74e732e794519bfff3079.svg";
export { ForwardRef as ReactComponent };